import {
  IFree30Message,
  IGuestSequence,
  ISequenceStep
} from "./free30-sequence.types";

const ABSENT: ISequenceStep = { present: false, at: null };

function isOutbound(m: IFree30Message): boolean {
  return (m.effectiveDirection || m.direction) === "outbound";
}
function isInbound(m: IFree30Message): boolean {
  return (m.effectiveDirection || m.direction) === "inbound";
}
function isManual(m: IFree30Message): boolean {
  return m.source === "app";
}

/** Earliest message (already sorted) matching pred, as a step. */
function firstStep(
  sorted: IFree30Message[],
  pred: (m: IFree30Message) => boolean
): ISequenceStep {
  const hit = sorted.find(pred);
  return hit ? { present: true, at: hit.sourceDateAdded } : ABSENT;
}

/**
 * Classify a guest's Free 30 contact sequence from their evidence messages.
 * Semantics match the server-side rollup: outbound+source!='app' = automation,
 * outbound+source=='app' = manual coach action, inbound = guest.
 * `booked` is always present (the caller only classifies booked guests).
 */
export function classifyFree30Sequence(
  messages: IFree30Message[],
  sessionDate: string | null
): IGuestSequence {
  const sorted = [...messages].sort((a, b) => {
    const ta = a.sourceDateAdded ? Date.parse(a.sourceDateAdded) : Infinity;
    const tb = b.sourceDateAdded ? Date.parse(b.sourceDateAdded) : Infinity;
    return ta - tb;
  });

  const sessionMs = sessionDate
    ? Date.parse(`${sessionDate}T23:59:59.999Z`)
    : null;

  return {
    booked: { present: true, at: null },
    autoText: firstStep(sorted, m => isOutbound(m) && !isManual(m)),
    coachReply: firstStep(sorted, m => isOutbound(m) && isManual(m)),
    guestReply: firstStep(sorted, m => isInbound(m)),
    callBeforeSession: firstStep(
      sorted,
      m =>
        m.messageType === "TYPE_CALL" &&
        isOutbound(m) &&
        isManual(m) &&
        (sessionMs === null ||
          (m.sourceDateAdded
            ? Date.parse(m.sourceDateAdded) <= sessionMs
            : false))
    )
  };
}
